import { render, staticRenderFns } from "./ExchangeRates.vue?vue&type=template&id=c3774e98&scoped=true"
import script from "./ExchangeRates.vue?vue&type=script&lang=js"
export * from "./ExchangeRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3774e98",
  null
  
)

export default component.exports